import { ContentCompletion } from '@/domain/usecases/content/content-completion'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads content completion data
 * Fetches completion information for an enrollment
 */
export async function loadContentCompletion(id: string) {
  const remote = await importRemote<ContentCompletion>('makeRemoteContentCompletion', queryClient)
  return remote.get(id)
}
